import { render } from "./M423_ChannelCallSelection.vue?vue&type=template&id=67bcf932&scoped=true"
import script from "./M423_ChannelCallSelection.vue?vue&type=script&lang=js"
export * from "./M423_ChannelCallSelection.vue?vue&type=script&lang=js"

import "./M423_ChannelCallSelection.vue?vue&type=style&index=0&id=67bcf932&scoped=true&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bcf932"]])

export default __exports__